import { renderDataCentreBlocks } from '../../util/BlockUtil';

const Facility = ({
  data,
  lang,
  width,
  global,
  popular_downloads_posts,
  related_content,
  tags,
}) => {
  return (
    <div id={'facility-template'} className="facility-template">
      {renderDataCentreBlocks({
        data,
        lang,
        width,
        global,
        popular_downloads_posts,
        related_content,
        tags,
      })}
    </div>
  );
};

export default Facility;
